export const translations = {
  INFOTEXT: {
    PFLICHTFELD_ANGABE: 'Mit * gekennzeichnete Felder sind Pflichtfelder'
  },
  INFO_DIALOG: {
    CLOSE: 'Schließen'
  },
  ERRORS: {
    REQUIRED: 'Bitte füllen Sie dieses Pflichtfeld aus.',
    INVALID: 'Diese Eingabe ist nicht gültig',
    SNACK_BAR: 'Bitte die rot angezeigten Fehler korrigieren.',
    SNACK_BAR_VOTUM: 'Leider ist ein Online-Abschluss auf Grundlage der eingegebenen Daten nicht möglich.',
    AVV_EINWILLIGUNG_FEHLT: 'Bitte akzeptieren Sie zuerst die Vereinbarung zum Auftragsverarbeitungsvertrag unter dem Menüpunkt ' +
        '"Weitere Antragsdaten" auf der Seite "Personendaten". Erst dann können Sie elektronisch unterschreiben.',
    EIGENE_MULTISEARCH_ANGABE: 'Bitte erst eine eigene Angabe im rot markierten Eingabefeld angeben und dann auf diesen Button klicken.',
    SPEICHERN_AVV_EINWILLIGUNG: 'Bitte stimmen Sie zuerst der Vereinbarung zur Auftragsverarbeitung zu. Sie finden sie unter dem Menüpunkt ' +
        '"Weitere Antragsdaten" auf der Seite "Personendaten".',
    VERMITTLER_DATEN_FEHLEN: 'Bitte befüllen Sie zuerst Ihre Vermittlernummer unter dem Menüpunkt "Antragsunterlagen" auf der Seite ' +
        '"Vermittler". Erst dann können Sie elektronisch unterschreiben.',
    INPUT: {
      MAXIMUM_CHARACTERS: 'Bitte geben Sie höchstens {x} Zeichen ein',
      MINIMUM_CHARACTERS: 'Bitte geben Sie mindestens {x} Zeichen ein'
    },
    INDIVIDUELLE_FONDS_FEHLEN: 'Bitte fügen Sie mindestens einen Fonds hinzu.',
    FONDS_NICHT_VERFUEGBAR: 'Diesen Fonds bieten wir nicht mehr an, bitte löschen und falls nötig ersetzen.',
    GESAMTPORTFOLIO_MAX_ZWANZIG_FONDS: 'Bitte wählen Sie maximal 20 Fonds.',
    GESAMTPORTFOLIO_UNGLEICH_EINHUNDERT_PROZENT: 'Das Gesamtportfolio muss 100% ergeben.',
    KEINE_OPTION_GEWAEHLT_VERMITTLERPORTFOLIO_VERAENDERT_MODAL: 'Bitte treffen Sie eine Auswahl',
    FONDS: {
      PORTFOLIO_NAME_BEREITS_VERGEBEN: 'Es existiert bereits eine Vorlage mit diesem Titel. Bitte verwenden Sie einen anderen Titel.'
    }
  },
  MODAL_DIALOG: {
    BUTTON_ABBRECHEN: 'Abbrechen',
    BUTTON_WEITER: 'Weiter',
    UEBERNEHMEN: 'ÜBERNEHMEN',
    PRUEFUNG: 'Moment bitte, wir prüfen die Eingabedaten...',
    PRUEFUNG_ABGESCHlOSSEN: 'Die Prüfung ist jetzt abgeschlossen',
    ANTRAG_SPEICHERN: {
      TITEL: 'Antragsdaten speichern',
    },
    WECHSEL_ANLAGESTRATEGIE: {
      TITEL: 'Anlageart wechseln?',
      MELDUNG: 'Ihre Eingaben zum individuellen Portfolio gehen beim Wechseln der Anlageart verloren.',
      BUTTON_ABBRECHEN: 'Abbrechen',
      BUTTON_WEITER: 'Wechseln',
    },
    FONDS: {
      VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN: {
        TITEL: 'Portfolio als Vorlage speichern',
        MELDUNG: 'Sie möchten dieses Portfolio auch für zukünftige Berechnungen wiederverwenden und direkt griffbereit haben? ' +
            '<br>Dann können Sie es jetzt ganz einfach als Vorlage abspeichern.',
        BUTTON_ABBRECHEN: 'Abbrechen',
        BUTTON_SPEICHERN: 'Speichern',
      },
      VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL: {
        TITEL: 'Portfolio als Vorlage speichern',
        MELDUNG: 'Sie haben Änderungen an folgender Portfoliovorlage vorgenommen:',
        SUB_MELDUNG: 'Wie möchten Sie damit fortfahren?*',
        OPTION_UEBRSCHREIBEN: 'Änderungen übernehmen und Vorlage überschreiben',
        OPTION_SPEICHERN: 'Als neue Vorlage speichern',
        OPTION_SPEICHERN_TITEL: 'Titel',
        BUTTON_ABBRECHEN: 'Abbrechen',
        BUTTON_SPEICHERN: 'Speichern',
      },
      VERMITTLERSPEZIFISCHES_PORTFOLIO_BEARBEITET_WECHSELN: {
        TITEL: 'Wirklich wechseln?',
        MELDUNG: 'Ihre Eingaben zum individuellen Portfolio gehen beim Wechseln verloren',
        BUTTON_ABBRECHEN: 'Abbrechen',
        BUTTON_WEITER: 'Wechseln',
      },
      VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_ANTEIL_FEHLERHAFT: {
        TITEL: 'Bitte Anteile korrigieren',
        MELDUNG: 'Um speichern zu können, müssen die Anteile Ihres Portfolios in Summe 100 % ergeben.',
        BUTTON_WEITER: 'Ok',
      },
      VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_FEHLENDE_ANGABEN: {
        TITEL: 'Bitte fehlende Angaben ergänzen',
        MELDUNG: 'Um speichern zu können, ergänzen Sie bitte die noch fehlenden Angaben im Portfolio.',
        BUTTON_WEITER: 'Ok',
      },
      LABEL: {
        FONDSSUCHE: 'Fondssuche',
        FONDSSUCHE_PLACEHOLDER: 'Fondsname/ISIN',
        INVESTMENTSTIL: 'Investmentstil',
        ESG_EINSTUFUNG: 'ESG-Einstufung',
        FONDSKATEGORIE: 'Fondskategorie',
        REGION: 'Region',
        THEMA: 'Thema',
        PAI_BERUECKSICHTIGUNG: 'PAI-Berücksichtigung',
        MINDEST_ANTEIL_NACHHALTIGE_INVESTITIONEN: 'Mindestanteil nachhaltiger Investitionen',
        MINDEST_ANTEIL_OEKOLOGISCHE_INVESTITIONEN: 'Mindestanteil ökologisch nachhaltiger Investitionen',
      },
      TOOLTIPS: {
        INVESTMENTSTIL: 'Gibt an, ob ein Fonds durch Kapitalanlageexperten aktiv gemanagt wird, oder ob ein Fonds (z.B. ein ETF) passiv in einen speziellen Markt(-index) investiert.',
        ESG_EINSTUFUNG: 'Gibt an, ob und inwieweit Ihr gewählter Fonds ökologische und oder soziale Entscheidungen verfolgt oder Nachhaltigkeitsrisiken gemäß Artikel 6, 8, 9 Offenlegungs-VO berücksichtigt. ' +
            'Artikel 6: Dieses Produkt weist auf Nachhaltigkeitsrisiken in seiner Anlageentscheidung hin und kann diese auch berücksichtigen. ' +
            'Artikel 8: Dieses Produkt fördert ökologische oder soziale Entscheidungen. ' +
            'Artikel 9: Dieses Produkt hat nachhaltige Investitionen zum Ziel (Impact Investment).',
        PAI_BERUECKSICHTIGUNG: '(PAI = Principle Adverse Impacts): Gibt an, welche wichtigsten negativen Auswirkungen auf Nachhaltigkeitsfaktoren durch Ihren Fonds berücksichtigt werden sollen. \n' +
            '* Treibhausgas-Emission: Vermeidung von negativen Auswirkungen durch Treibhausgasemission, z. B. aufgrund Verbrauch und Produktion fossiler Energien oder Ausstoß energieintensiver Sektoren. \n' +
            '* Wasser: Vermeidung von negativen Wasseremissionen.\n' +
            '* Abfälle: Vermeidung von umweltschädlichen Abfällen.\n' +
            '* Biologische Diversität: Vermeidung von negativen Auswirkungen auf biodiversitäts-sensible Gebiete, z. B. bauliche Maßnahmen in einem Naturschutzgebiet. \n' +
            '* Soziale - und Arbeitnehmerbelange: Vermeidung von z. B. Verstößen an Arbeits- und Menschenrechten oder kontroversen Waffen.',
        MINDEST_ANTEIL_NACHHALTIGE_INVESTITIONEN: 'Fonds mit einer Investition in eine wirtschaftliche Tätigkeit, die gemäß Offenlegungs-VO zur Erreichung eines Umwelt- oder sozialen Ziels beiträgt und keines dieser Ziele erheblich beeinträchtigt, sowie in Unternehmen investiert, die Verfahrensweisen einer guten Unternehmensführung anwenden.',
        MINDEST_ANTEIL_OEKOLOGISCHE_INVESTITIONEN: 'Fonds mit einer Investition in eine wirtschaftliche Tätigkeit, die gemäß Taxonomie-VO einen wesentlichen Beitrag zur Verwirklichung mindestens eines Umweltziels leistet sowie keines dieser Ziele erheblich beeinträchtigt.'
      }
    },
  },
  DATUM: {
    MONAT_UNGUELTIG: 'Dies ist kein gültiger Monat im Format MM.',
    JAHR_UNGUELTIG: 'Dies ist kein gültiges Jahr im Format JJJJ.',
    JAHR_ZU_KLEIN: 'Ein Jahr vor 1871 akzeptieren wir nicht.'
  },
  DOKUMENT_TREE_ELEMENT: {
    TOGGLE_BUTTON: {
      DOKUMENTE_VORVERTRAGLICHE_INFORMATIONEN: 'Nur Dokumente gemäß vorvertraglichen Informationen wählen'
    },
  },
  BUTTON_DOWNLOAD: {
    DOKUMENTE_NICHT_VERFUEGBAR: 'Die Antragsunterlagen können erst angezeigt werden, wenn Sie die Tarifdaten unter Berechnung eingegeben haben.',
    DOKUMENTE_AUSWAEHLEN: 'Alle Dokumente auswählen',
    DOKUMENTE_ABWAEHLEN: 'Alle Dokumente abwählen'
  },
  EIGENE_EINGABE_MOEGLICH_TEXT: 'War die gesuchte Erkrankung nicht dabei? Sie können eine Krankheit hier erfassen.',
  EIGENE_EINGABE_MOEGLICH_BUTTON: 'Eigene Eingabe',
  TOOLTIPS: {
    ABLAUFMANAGEMENT_FONDS: 'Bitte beachten Sie, dass für das Ablaufmanagement der aufgeführte Standardfonds hinterlegt wurde. ' +
        'Dieser kann während der Vertragslaufzeit durch die LV 1871 geändert werden. Kurz vor Beginn des Ablaufmanagements ' +
        'informieren wir Sie schriftlich darüber, dass Sie die Aufteilung sowie Art der Fonds anpassen können.'
  },
  FONDS: {
    PORTFOLIO_INDIVIDUELL: 'Individuelles Portfolio',
    PORTFOLIO_NEU_ODER_VORLAGE: 'Sie können entweder ein neues Portfolio erstellen oder aus Ihren bereits gespeicherten Portfoliovorlagen auswählen:',
    DROPDOWN: {
      PORTFOLIO_VORLAGEN: 'IHRE PORTFOLIOVORLAGEN',
      PORTFOLIO_KEINE_VORLAGEN_VORHANDEN: 'Sie haben noch keine Portfoliovorlagen gespeichert',
    }
  }
};
